/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q3Inputs */

const en_minifier_faq_q3 = /** @type {(inputs: Minifier_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I minify already minified JSON?`)
};

const ko_minifier_faq_q3 = /** @type {(inputs: Minifier_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 압축된 JSON을 다시 압축할 수 있나요?`)
};

const ja_minifier_faq_q3 = /** @type {(inputs: Minifier_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既に圧縮済みのJSONを圧縮できますか？`)
};

/**
* | output |
* | --- |
* | "Can I minify already minified JSON?" |
*
* @param {Minifier_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q3 = /** @type {((inputs?: Minifier_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q3(inputs)
	if (locale === "ko") return ko_minifier_faq_q3(inputs)
	return ja_minifier_faq_q3(inputs)
});